export default __webpack_public_path__ + "static/media/mccree-intro.5c95b11f.mp3";